var React = require('react');

function DownArrowThin (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m487.536 120.445c-4.16-4.16-10.923-4.16-15.083 0l-227.114 227.136-227.136-227.114c-4.16-4.16-10.923-4.16-15.083 0s-4.16 10.923 0 15.083l234.667 234.667c2.091 2.069 4.821 3.115 7.552 3.115s5.461-1.045 7.531-3.136l234.667-234.667c4.159-4.161 4.159-10.924-.001-15.084z"}));
}

DownArrowThin.defaultProps = {"enableBackground":"new 0 0 490.656 490.656","viewBox":"0 0 490.656 490.656"};

module.exports = DownArrowThin;

DownArrowThin.default = DownArrowThin;
